import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import Select from "react-select";
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { Comman_changeArrayFormat, Comman_changeArrayFormatwithoutcode, Comman_changeArrayFormatBasicInfowithoutcode, Comman_changeArrayFormatBasicInfo, Comman_changeArrayFormatJustfiableHomicide, threeColArray, threeColVictimInjuryArray, threeColArrayWithCode, offenseArray } from '@/Components/Common/ChangeArrayFormat';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from '@/Context/Agency';
import { components } from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { get_LocalStoreData } from '@/redux/api';
import { Decrypt_Id_Name, isLockOrRestrictModule, MultiSelectLockedStyle, nibrscolourStyles } from '@/Components/Common/Utility';
import NameListing from '@/Components/Pages/ShowAllList/NameListing';
import ListModal from '@/Components/Pages/Utility/ListManagementModel/ListModal';
import { assult_Type_Nibrs_Errors, check_injuryType_Nibrs, check_justifiy_Homicide, ErrorStyle_VictimHome, ErrorTooltipComp } from '@/Components/Pages/Name/NameNibrsErrors';
import { useNibrs } from '@/Context/NIBRS/NibrsLeftTreeContext';

const ALLOWED_INJURY_TYPES_FOR_13B = new Set(['M - Apparent Minor Injury', 'N - None']);
const FIREARM_NIBRS_WEAPON_CODES = new Set([11, 12, 13, 14, 15]);
const ALLOWED_INJURY_OFFENSE_CODES = new Set(['100', '09A', '09B', '09C', '11A', '11B', '11C', '11D', '120', '13A', '13B', '210', '64A', '64B']);

const parseWeaponCodeNumbers = (weaponCodes) => {
    if (weaponCodes == null || weaponCodes === '') return [];
    if (Array.isArray(weaponCodes)) {
        return weaponCodes
            .map((c) => Number(String(c).trim()))
            .filter((n) => !Number.isNaN(n));
    }
    return String(weaponCodes)
        .split(',')
        .map((s) => Number(s.trim()))
        .filter((n) => !Number.isNaN(n));
};

const offenseWeaponCodesIncludeFirearm = (weaponCodes) => {
    return parseWeaponCodeNumbers(weaponCodes).some((code) => FIREARM_NIBRS_WEAPON_CODES.has(code));
}

const Home = (props) => {
    const { refetchNibrsLeftTreeErrors } = useNibrs();
    const { DecNameID, DecMasterNameID, DecIncID, victimID, offenceCodes, victimCode, weaponCodes, nibFieldStatusOrErr, isCrimeAgainsPerson, isLocked } = props
    const { get_NameVictim_Count, get_Name_Count, nibrsSubmittedName, get_Offence_Data } = useContext(AgencyContext);
    const dispatch = useDispatch();
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const loginAgencyState = useSelector((state) => state.Ip.loginAgencyState);
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const SelectedValue = useRef();
    const [propertyDrp, setPropertyDrp] = useState();
    const [justifiableHomiDrp, setJustifiableHomiDrp] = useState();
    const [justifiableHomiVal, setJustifiableHomiVal] = useState();
    const [officerDrpData, setOfficerDrpData] = useState();
    const [injuryTypeDrp, setInjuryTypeDrp] = useState();
    const [assaultDrp, setAssaultDrp] = useState();
    const [loginAgencyID, setLoginAgencyID] = useState('');
    const [loginPinID, setLoginPinID,] = useState('');
    const [nameID, setNameID] = useState('');
    const [incidentID, setIncidentID] = useState();
    const [assultCodeArr, setAssultCodeArr] = useState([]);
    const [typeOfSecurityEditVal, setTypeOfSecurityEditVal] = useState();
    const [propertyEditVal, setPropertyEditVal] = useState();
    const [injuryTypeEditVal, setInjuryTypeEditVal] = useState();
    const [assaultEditVal, setAssaultEditVal] = useState();
    const [isFirearmRelatedOffense, setIsFirearmRelatedOffense] = useState(false);

    //ids
    const [officerID, setofficerID] = useState();
    const [justifiyID, setJustifiyID] = useState();
    const [victimInjuryID, setVictimInjuryID] = useState();
    const [assaultID, setAssaultID] = useState();
    const [propertyID, setPropertyID] = useState();
    const [openPage, setOpenPage] = useState('');
    const [selectedNameOffenseData, setSelectedNameOffenseData] = useState();
    const [isJustifiableHomicideFieldHovered, setIsJustifiableHomicideFieldHovered] = useState(false);
    const [isInjuryTypeFieldHovered, setIsInjuryTypeFieldHovered] = useState(false);
    const [isAssaultFieldHovered, setIsAssaultFieldHovered] = useState(false);
    const MultiValue = props => (
        <components.MultiValue {...props}>
            <span>{props.data.label}</span>
        </components.MultiValue>
    );


    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
    }, []);


    useEffect(() => {
        const hasFirearm = Array.isArray(selectedNameOffenseData)
            && selectedNameOffenseData?.some((item) => offenseWeaponCodesIncludeFirearm(item.WeaponCodes));
        setIsFirearmRelatedOffense(Boolean(hasFirearm));
    }, [selectedNameOffenseData]);

    useEffect(() => {
        if (localStoreData) {
            setLoginAgencyID(localStoreData?.AgencyID); setLoginPinID(localStoreData?.PINID);

        }
    }, [localStoreData]);

    useEffect(() => {
        if (DecNameID) { setNameID(DecNameID); setIncidentID(DecIncID); }
    }, [DecNameID, loginPinID,]);

    const get_OffenseName_Data = (DecNameID) => {
        const val = { 'NameID': DecNameID, }
        fetchPostData('NameOffense/GetData_NameOffense', val).then((res) => {
            if (res) {
                setSelectedNameOffenseData(offenseArray(res, 'NameOffenseID', 'OffenseID', 'NameID', 'NameID', 'Offense_Description', 'PretendToBeID', '', 'FBICode', 'WeaponCodes'));
            } else {
                setSelectedNameOffenseData([]);
            }
        }).catch((err) => {
            console.error("🚀 ~ getOffenseData ~ err:", err);
        })
    }

    useEffect(() => {
        get_OffenseName_Data(DecNameID)
    }, [DecNameID])


    useEffect(() => {
        if (victimID) {
            get_Property_Data(victimID); get_Victim_Officer_Data(victimID); get_RelationShip_Data(victimID); get_InjuryType_Data(victimID); get_Assults_Data(victimID); get_Data_RelationShip_Drp(victimID); get_Data_InjuryType_Drp(victimID);
            get_Assults_Drp(victimID); get_Property_DropDown(DecIncID, victimID);
            get_NameVictim_Count(victimID); get_Victim_Officer_Drp(victimID, loginAgencyID);
        }
    }, [victimID])

    useEffect(() => {
        if (typeOfSecurityEditVal) { setofficerID(typeOfSecurityEditVal) }
    }, [typeOfSecurityEditVal])

    useEffect(() => {
        if (justifiableHomiVal) {
            setJustifiyID(justifiableHomiVal)
        }
    }, [justifiableHomiVal])

    useEffect(() => {
        if (injuryTypeEditVal) { setVictimInjuryID(injuryTypeEditVal) }
    }, [injuryTypeEditVal])

    useEffect(() => {
        if (assaultEditVal) {
            setAssaultID(assaultEditVal)
            const assultArray = assaultEditVal?.map((item) => item?.code);
            setAssultCodeArr(assultArray);
        }
    }, [assaultEditVal])

    useEffect(() => {
        if (propertyEditVal) { setPropertyID(propertyEditVal) }
    }, [propertyEditVal])

    const get_InjuryType_Data = (victimID) => {
        const val = { 'VictimID': victimID, }
        fetchPostData('InjuryVictim/GetData_InjuryVictim', val).then((res) => {
            if (res) {
                setInjuryTypeEditVal(Comman_changeArrayFormatBasicInfowithoutcode(res, 'VictimInjuryID', 'NameID', 'PretendToBeID', 'NameEventInjuryID', 'VictimInjury_Description'));
            } else {
                setInjuryTypeEditVal([]);
            }
        })
    }

    const get_Data_InjuryType_Drp = (incidentID, victimID) => {
        const val = { 'IncidentID': incidentID, 'VictimID': victimID }
        fetchPostData('InjuryVictim/GetData_InsertVictimInjury', val).then((data) => {
            if (data) {
                setInjuryTypeDrp(threeColVictimInjuryArray(data, 'VictimInjuryID', 'Description', 'InjuryCode'))
            } else {
                setInjuryTypeDrp([])
            }
        })
    }

    const get_RelationShip_Data = (victimID) => {
        const val = { 'VictimID': victimID, }
        fetchPostData('VictimJustifiableHomicide/GetData_VictimJustifiableHomicide', val).then((res) => {
            if (res) {
                setJustifiableHomiVal(Comman_changeArrayFormatJustfiableHomicide(res, 'VictimJustifiableHomicideID', 'JustifiableHomicideID', 'PretendToBeID', 'JustifiableHomicide_Description', 'JustifiableHomicideCode'));

            } else {
                setJustifiableHomiVal([]);
            }
        })
    }

    const get_Data_RelationShip_Drp = (victimID) => {
        const val = { 'VictimID': victimID }
        fetchPostData('VictimJustifiableHomicide/GetData_InsertJustifiableHomicide', val).then((data) => {
            if (data) {
                setJustifiableHomiDrp(threeColVictimInjuryArray(data, 'JustifiableHomicideID', 'Description', "JustifiableHomicideCode",))

            } else {
                setJustifiableHomiDrp([])
            }
        })
    }

    const get_Victim_Officer_Data = (victimID) => {
        const val = { 'VictimID': victimID, }
        fetchPostData('VictimOfficer/GetData_VictimOfficer', val).then((res) => {
            if (res) {
                setTypeOfSecurityEditVal(Comman_changeArrayFormatwithoutcode(res, 'VictimOfficerID', 'NameID', 'PretendToBeID', 'OfficerID', 'Officer_Name'));
            } else {
                setTypeOfSecurityEditVal([]);
            }
        })
    }

    const get_Victim_Officer_Drp = (victimID, loginAgencyID) => {
        const val = { 'VictimID': victimID, 'AgencyID': loginAgencyID, 'IncidentID': 0 }
        fetchPostData('VictimOfficer/GetData_InsertVictimOfficer', val).then((data) => {
            if (data) {
                setOfficerDrpData(Comman_changeArrayFormat(data, 'PINID', 'HeadOfAgency'))
            } else {
                setOfficerDrpData([])
            }
        })
    }

    const get_Assults_Data = (victimID) => {
        const val = { 'VictimID': victimID, }
        fetchPostData('VictimAssaultType/GetData_VictimAssaultType', val).then((res) => {
            if (res) {
                setAssaultEditVal(Comman_changeArrayFormatBasicInfo(res, 'NameEventAssaultID', 'Assault_Description', 'PretendToBeID', 'AssaultID', 'AssaultCode'));

            } else {
                setAssaultEditVal([]);
            }
        })
    }

    const get_Assults_Drp = (victimID) => {
        const val = { 'VictimID': victimID, }
        fetchPostData('VictimAssaultType/GetData_InsertVictimAssaultType', val).then((data) => {
            if (data) {

                setAssaultDrp(threeColArrayWithCode(data, 'AssaultTypeID', 'Description', 'AssaultCode'));

            } else {
                setAssaultDrp([])
            }
        })
    }

    const get_Property_Data = (victimID) => {
        const val = { 'VictimID': victimID }
        fetchPostData('VictimProperty/GetData_VictimProperty', val).then((res) => {
            if (res) {
                setPropertyEditVal(Comman_changeArrayFormatwithoutcode(res, 'VictimPropertyID', 'NameID', 'PretendToBeID', 'PropertyID', 'Description'));
            } else {
                setPropertyEditVal([]);
            }
        })
    }

    const get_Property_DropDown = (incidentID, victimID) => {
        const val = { 'IncidentID': incidentID, 'VictimID': victimID, }
        fetchPostData('VictimProperty/GetData_InsertVictimProperty', val).then((data) => {
            if (data) {
                setPropertyDrp(threeColArray(data, 'PropertyID', 'Description'))
            } else {
                setPropertyDrp([])
            }
        })
    }

    const InSertBasicInfo = (id, col1, url) => {

        const val = {
            'NameID': nameID,
            'VictimID': victimID,
            [col1]: id,
            'CreatedByUserFK': loginPinID,
        }
        AddDeleteUpadate(url, val).then((res) => {
            if (res) {
                get_Name_Count(DecNameID, DecMasterNameID);
                const parsedData = JSON.parse(res.data);
                const message = parsedData.Table[0].Message;
                toastifySuccess(message);
                refetchNibrsLeftTreeErrors();

                col1 === 'OfficerID' && get_Victim_Officer_Data(victimID); get_Victim_Officer_Drp(victimID, loginAgencyID);
                col1 === 'PropertyID' && get_Property_Data(victimID); get_Property_DropDown(incidentID, victimID);
                col1 === 'JustifiableHomicideID' && get_RelationShip_Data(victimID); get_Data_RelationShip_Drp(victimID);
                col1 === 'VictimInjuryID' && get_InjuryType_Data(victimID);
                col1 === 'AssaultID' && get_Assults_Data(victimID); get_Assults_Drp(victimID)
            }
        })
    }

    const DelSertBasicInfo = (victimOfficerID, col1, url) => {

        const val = {
            [col1]: victimOfficerID,
            'DeletedByUserFK': loginPinID,
        }
        AddDeleteUpadate(url, val).then((res) => {
            if (res) {
                get_Name_Count(DecNameID, DecMasterNameID);
                const parsedData = JSON.parse(res.data);
                const message = parsedData.Table[0].Message;
                toastifySuccess(message);
                refetchNibrsLeftTreeErrors();

                if (col1 === 'VictimOfficerID') {
                    get_Victim_Officer_Data(victimID);
                    get_Victim_Officer_Drp(victimID, loginAgencyID);
                }

                else if (col1 === 'VictimPropertyID') {
                    get_Property_Data(victimID);
                    get_Property_DropDown(incidentID, victimID);
                } else if (col1 === 'VictimJustifiableHomicideID') {
                    get_RelationShip_Data(victimID);
                    get_Data_RelationShip_Drp(victimID);
                } else if (col1 === 'NameEventInjuryID') {
                    get_InjuryType_Data(victimID);
                } else if (col1 === 'NameEventAssaultID') {
                    get_Assults_Data(victimID);
                    get_Assults_Drp(victimID);
                }
            }
        })
    }

    const officerOnChange = (multiSelected) => {

        setofficerID(multiSelected)
        const len = multiSelected.length - 1
        if (multiSelected?.length < typeOfSecurityEditVal?.length) {
            let missing = null;
            let i = typeOfSecurityEditVal.length;
            while (i) {
                missing = (~multiSelected.indexOf(typeOfSecurityEditVal[--i])) ? missing : typeOfSecurityEditVal[i];
            }
            DelSertBasicInfo(missing.value, 'VictimOfficerID', 'VictimOfficer/Delete_VictimOfficer')
            refetchNibrsLeftTreeErrors();
        } else {
            InSertBasicInfo(multiSelected[len].value, 'OfficerID', 'VictimOfficer/Insert_VictimOfficer')
            refetchNibrsLeftTreeErrors();
        }
    }

    const JustifuableOnChange = (selectedOption) => {
        const nextSelected = selectedOption ? [selectedOption] : [];
        const previousSelected = Array.isArray(justifiableHomiVal) ? justifiableHomiVal : [];
        const previous = previousSelected[0];
        const next = nextSelected[0];

        setJustifiyID(nextSelected);

        if (!next && previous?.id) {
            DelSertBasicInfo(previous.id, 'VictimJustifiableHomicideID', 'VictimJustifiableHomicide/Delete_VictimJustifiableHomicide');
            return;
        }

        if (!next) return;

        const isSameSelection =
            previous &&
            String(previous.value ?? '') === String(next.value ?? '');

        if (previous?.id && !isSameSelection) {
            DelSertBasicInfo(previous.id, 'VictimJustifiableHomicideID', 'VictimJustifiableHomicide/Delete_VictimJustifiableHomicide');
        }

        if (!isSameSelection) {
            InSertBasicInfo(next.value, 'JustifiableHomicideID', 'VictimJustifiableHomicide/Insert_VictimJustifiableHomicide');
        }
    }

    const InjuryTypeOnChange = (multiSelected) => {
        const nextSelected = multiSelected || [];

        if (nextSelected.length > 5) {
            toastifyError('You can select a maximum of 5 injury type at a time.');
            return;
        }

        setVictimInjuryID(nextSelected)
        const len = nextSelected.length - 1
        if (nextSelected?.length < injuryTypeEditVal?.length) {
            let missing = null;
            let i = injuryTypeEditVal.length;
            while (i) {
                missing = (~nextSelected.indexOf(injuryTypeEditVal[--i])) ? missing : injuryTypeEditVal[i];
            }
            DelSertBasicInfo(missing.id, 'NameEventInjuryID', 'InjuryVictim/Delete_VictimInjury')
        } else {
            InSertBasicInfo(nextSelected[len].value, 'VictimInjuryID', 'InjuryVictim/Insert_VictimInjury')
        }
    }

    const assaultOnChange = (multiSelected) => {
        const nextSelected = multiSelected || [];

        if (nextSelected.length > 2) {
            toastifyError('You can select a maximum of 2 Assault type at a time.');
            return;
        }

        setAssaultID(nextSelected)
        const len = nextSelected.length - 1
        if (nextSelected?.length < assaultEditVal?.length) {
            let missing = null;
            let i = assaultEditVal.length;
            while (i) {
                missing = (~nextSelected.indexOf(assaultEditVal[--i])) ? missing : assaultEditVal[i];
            }
            DelSertBasicInfo(missing.value, 'NameEventAssaultID', 'VictimAssaultType/Delete_VictimAssaultType')
        } else {
            InSertBasicInfo(nextSelected[len].value, 'AssaultID', 'VictimAssaultType/Insert_VictimAssaultType')
        }
    }

    const PropertyOnChange = (multiSelected) => {

        setPropertyID(multiSelected)
        const len = multiSelected.length - 1
        if (multiSelected?.length < propertyEditVal?.length) {
            let missing = null;
            let i = propertyEditVal.length;
            while (i) {
                missing = (~multiSelected.indexOf(propertyEditVal[--i])) ? missing : propertyEditVal[i];
            }
            DelSertBasicInfo(missing.value, 'VictimPropertyID', 'VictimProperty/Delete_VictimProperty')
        } else {
            InSertBasicInfo(multiSelected[len].value, 'PropertyID', 'VictimProperty/Insert_VictimProperty')
        }
    }

    const customStylesWithOutColor = {
        control: base => ({
            ...base,
            fontSize: 14,
            margintop: 2,
            boxShadow: 0,
        }),
    };

    const hasAssaultType20Or21 = useMemo(() => {
        const list = Array.isArray(assaultID) ? assaultID : [];
        const fromSelection = list.some((item) => {
            const c = String(item?.code ?? '').trim();
            return c === '20' || c === '21';
        });
        if (fromSelection) return true;
        const codes = Array.isArray(assultCodeArr) ? assultCodeArr : [];
        return codes.some((c) => {
            const s = String(c ?? '').trim();
            return s === '20' || s === '21';
        });
    }, [assaultID, assultCodeArr]);

    const assaultNibrsErrorMessage =
        assultCodeArr?.includes("08") && offenceCodes?.length < 2
            ? 'Must have multiple offenses when Assault/Homicide Circumstances = 08'
            : assultCodeArr?.length > 0 ? assult_Type_Nibrs_Errors(assultCodeArr, offenceCodes, 'Message') : "";


    /** Assault Type is only valid when the name has at least one of these offense FBI codes. */
    const ASSAULT_ALLOWED_OFFENSE_FBICODES = new Set(['13A', '09A', '09B', '09C']);
    const hasQualifyingOffenseForAssault = (offenseData) => {
        if (!Array.isArray(offenseData) || offenseData.length === 0) return false;
        return offenseData.some((item) => {
            const code = item?.FBICode != null ? String(item.FBICode).trim() : '';
            return ASSAULT_ALLOWED_OFFENSE_FBICODES.has(code);
        });
    };

    /** Assault is set but name offenses are missing or have no 13A/09A/09B/09C (does not block selection). */
    const showAssaultOffenseMismatchError =
        assaultID?.length > 0 && !hasQualifyingOffenseForAssault(selectedNameOffenseData);

    const assaultValidationMessages = useMemo(() => {
        const msgs = [];
        if (loginAgencyState === 'TX' && assaultNibrsErrorMessage) msgs.push(assaultNibrsErrorMessage);
        if (assultCodeArr?.find((item) => item === '10') && assaultID?.length > 1) {
            msgs.push('Error - Unknown is mutually exclusive and must be entered alone.');
        }
        if (offenceCodes?.find((item) => item === '13A') && assaultID?.find((item) => item?.code === '07')) {
            msgs.push('Error: Invalid selection of Assault Type for Offense 13A - Aggravated Assault');
        }
        if (showAssaultOffenseMismatchError) {
            msgs.push('Invalid: Assault Type may only be entered with offenses 09A - 09C, 13A.');
        }
        if (offenceCodes?.some((item) => ['13A', '09A', '09B', '09C'].includes(item)) && assultCodeArr?.length === 0) {
            msgs.push('Error: For the selected offense Assault Type is mandatory.');
        }
        return msgs;
    }, [
        loginAgencyState,
        assaultNibrsErrorMessage,
        assultCodeArr,
        assaultID,
        offenceCodes,
        showAssaultOffenseMismatchError,
    ]);
    const isAggravatedAssaultPersonalWeaponRule = () => {
        if (!Array.isArray(victimInjuryID) || victimInjuryID.length === 0) return false;

        const hasNoneOrMinorInjury = victimInjuryID.some((item) => {
            const normalized = String(item?.code || item?.label || '').trim();
            return normalized === 'N - None' || normalized === 'M - Apparent Minor Injury';
        });

        const has13AOffense = Array.isArray(offenceCodes)
            && offenceCodes.some((code) => String(code || '').trim() === '13A');
        const has40Weapon = Array.isArray(weaponCodes)
            && weaponCodes.some((code) => String(code || '').trim() === '40');
        return hasNoneOrMinorInjury && has13AOffense && has40Weapon;
    };

    const injuryValidationMessages = useMemo(() => {
        const msgs = [];
        if (victimInjuryID?.find((item) => item?.code === 'N - None') && victimInjuryID?.length > 1) {
            msgs.push('Error - None is mutually exclusive and must be entered alone.');
        }
        const has13B =
            Array.isArray(offenceCodes) &&
            offenceCodes.some((c) => String(c).trim() === '13B');
        if (
            has13B &&
            Array.isArray(victimInjuryID) &&
            victimInjuryID.length > 0 &&
            victimInjuryID.some((item) => {
                const code = item?.code ?? item?.label;
                const normalized = code != null ? String(code).trim() : '';
                if (!normalized) return false;
                return !ALLOWED_INJURY_TYPES_FOR_13B.has(normalized);
            })
        ) {
            msgs.push('Error: For offense 13B - Simple Assault, injury type must be M - Apparent Minor Injury or N - None only.');
        }

        if (victimInjuryID?.find((item) => item?.code === 'G - Gunshot Wound') && victimInjuryID?.length >= 1 && !isFirearmRelatedOffense) {
            msgs.push('Error: Selected Injury Type ‘Gunshot Wound’ requires at least one selected Associated Offense to have a firearm weapon type.');
        }

        if (isAggravatedAssaultPersonalWeaponRule()) {
            msgs.push(
                'When the selected associated offense is 13A = Aggravated Assault and the selected weapon is 40 = Personal Weapons, the injury type cannot be N = None or M = Apparent Minor Injury.'
            );
        }

        const hasInvalidInjuryOffenseCode =
            Array.isArray(offenceCodes) &&
            !offenceCodes.some((code) => ALLOWED_INJURY_OFFENSE_CODES.has(String(code ?? '').trim())) && victimInjuryID?.length > 0;

        if (hasInvalidInjuryOffenseCode) {
            msgs.push(
                'Invalid: Injury Type may only be entered with offenses 100, 09A - 09C, 11A - 11D, 120, 13A, 13B, 210, 64A, 64B.'
            );
        }


        if (offenceCodes?.some((item) => ['100', '09A', '09B', '09C', '11A', '11B', '11C', '11D', '120', '13A', '13B', '210', '64A', '64B'].includes(item)) && victimInjuryID?.length === 0) {
            msgs.push('Error: For the selected offense Injury Type is mandatory.');
        }
        return msgs;
    }, [offenceCodes, weaponCodes, victimInjuryID, isFirearmRelatedOffense]);

    return (
        <>
            <NameListing />
            <div className="col-12 " id='display-not-form'>
                {/* <div className="col-12 col-md-12  p-0" >
                    <div className="bg-line  py-1 px-2 d-flex justify-content-between align-items-center">
                        <p className="p-0 m-0">Other Victim</p>
                    </div>
                </div> */}
                <div className="row pt-1">
                    <div className="col-2 col-md-2 col-lg-2 mt-3">
                        <label htmlFor="" className='label-name '>Officer</label>
                    </div>
                    <div className="col-4 col-md-4 col-lg-4  mt-2" >
                        <Select
                            name='OfficerID'
                            value={officerID}
                            options={officerDrpData}
                            isClearable={false}
                            closeMenuOnSelect={false}
                            placeholder="Select.."
                            ref={SelectedValue}
                            className="basic-multi-select"
                            isMulti
                            menuPlacement="bottom"
                            menuPortalTarget={null}
                            components={{ MultiValue, }}
                            onChange={(e) => officerOnChange(e)}
                            // styles={customStylesWithOutColor}
                            styles={isLockOrRestrictModule("Lock", typeOfSecurityEditVal, isLocked, true) ? MultiSelectLockedStyle : customStylesWithOutColor}
                            isDisabled={isLockOrRestrictModule("Lock", typeOfSecurityEditVal, isLocked, true) ? true : false}
                        />
                    </div>
                    <div className="col-2 col-md-2 col-lg-2 mt-4">
                        {/* <span data-toggle="modal" data-target="#ListModel" className='new-link'> */}
                        <label htmlFor="" className='label-name '>Additional Justifiable Homicide</label>
                        {
                            loginAgencyState === 'TX' ?
                                nibFieldStatusOrErr?.JustHomicide ? <ErrorTooltipComp ErrorStr={nibFieldStatusOrErr?.JustHomicideError} />
                                    :
                                    check_justifiy_Homicide(assultCodeArr, justifiyID, offenceCodes, 'Tooltip')
                                :
                                null
                        }
                        {/* </span> */}
                    </div>
                    <div
                        className="col-4 col-md-4 col-lg-4  mt-2"
                        onMouseEnter={() => setIsJustifiableHomicideFieldHovered(true)}
                        onMouseLeave={() => setIsJustifiableHomicideFieldHovered(false)}
                    >
                        {isJustifiableHomicideFieldHovered && justifiyID?.length > 0 && !hasAssaultType20Or21 &&
                            (<div className="nibrs-tooltip-error" style={{ left: '-190px', pointerEvents: 'none' }} aria-hidden="true">
                                <div className="tooltip-arrow" />
                                <div className="tooltip-content">
                                    <span className="text-danger" style={{ whiteSpace: 'pre-line' }}>
                                        {"Invalid: Additional Justifiable Homicide circumstance is required when a Assault Type is 20 or 21."}
                                    </span>
                                </div>
                            </div>)}
                        <Select
                            name='JustifiableHomicideID'
                            value={Array.isArray(justifiyID) ? justifiyID[0] || null : justifiyID}
                            options={justifiableHomiDrp}
                            closeMenuOnSelect
                            placeholder="Select.."
                            isClearable
                            ref={SelectedValue}
                            onChange={(e) => JustifuableOnChange(e)}
                            className="basic-multi-select"
                            menuPlacement="bottom"
                            menuPortalTarget={null}
                            styles={
                                isLockOrRestrictModule("Lock", justifiableHomiVal, isLocked, true) ? MultiSelectLockedStyle :
                                    (justifiyID?.length > 0 && !hasAssaultType20Or21) ? nibrscolourStyles :
                                        loginAgencyState === 'TX' ?
                                            offenceCodes?.includes('09C') ? ErrorStyle_VictimHome(true) :
                                                check_justifiy_Homicide(assultCodeArr, justifiyID, offenceCodes, 'Color') ? check_justifiy_Homicide(assultCodeArr, justifiyID, offenceCodes, 'Color') : customStylesWithOutColor
                                            :
                                            customStylesWithOutColor
                            }
                            isDisabled={isLockOrRestrictModule("Lock", justifiableHomiVal, isLocked, true) ? true : false}
                        />
                    </div>
                    <div className="col-2 col-md-2 col-lg-2 mt-3">
                        <label htmlFor="" className='label-name '>Injury Type
                            {
                                loginAgencyState === 'TX' ?
                                    nibFieldStatusOrErr?.InjuryType ? <ErrorTooltipComp ErrorStr={nibFieldStatusOrErr?.InjuryTypeError} />
                                        :
                                        <></>
                                    :
                                    <>
                                    </>
                            }
                        </label>
                    </div>
                    <div
                        className="col-4 col-md-4 col-lg-4  mt-2"
                        onMouseEnter={() => setIsInjuryTypeFieldHovered(true)}
                        onMouseLeave={() => setIsInjuryTypeFieldHovered(false)}
                    >
                        {isInjuryTypeFieldHovered && injuryValidationMessages.length > 0 && (
                            <div className="nibrs-tooltip-error" style={{ left: '-190px', pointerEvents: 'none' }} aria-hidden="true">
                                <div className="tooltip-arrow" />
                                <div className="tooltip-content">
                                    <span className="text-danger" style={{ whiteSpace: 'pre-line' }}>
                                        {`${injuryValidationMessages.map((m) => `⚠️ ${m}`).join('\n')}`}
                                    </span>
                                </div>
                            </div>
                        )}
                        <Select
                            name='VictimInjuryID'
                            value={victimInjuryID}
                            isClearable={false}
                            options={injuryTypeDrp}
                            closeMenuOnSelect={false}
                            placeholder="Select.."
                            ref={SelectedValue}
                            components={{ MultiValue, }}
                            onChange={(e) => InjuryTypeOnChange(e)}
                            className="basic-multi-select"
                            isMulti
                            menuPlacement="bottom"
                            menuPortalTarget={null}
                            // styles={customStylesWithOutColor}
                            // isDisabled={nibrsSubmittedName === 1 && victimInjuryID?.length > 0}
                            styles={isLockOrRestrictModule("Lock", injuryTypeEditVal, isLocked, true) ? MultiSelectLockedStyle : injuryValidationMessages.length > 0 ? nibrscolourStyles : (offenceCodes?.some((item) => ['13A', '09A', '09B', '09C'].includes(item)) && victimInjuryID?.length === 0) || isAggravatedAssaultPersonalWeaponRule() ? nibrscolourStyles : customStylesWithOutColor}
                            isDisabled={isLockOrRestrictModule("Lock", injuryTypeEditVal, isLocked, true) || (nibrsSubmittedName === 1 && victimInjuryID?.length > 0)}
                        />
                    </div>
                    <div className="col-2 col-md-2 col-lg-2 mt-3">
                        <label htmlFor="" className='label-name '>Assault Type</label>
                    </div>
                    <div
                        className="col-4 col-md-4 col-lg-4  mt-2"
                        onMouseEnter={() => setIsAssaultFieldHovered(true)}
                        onMouseLeave={() => setIsAssaultFieldHovered(false)}
                    >
                        {isAssaultFieldHovered && assaultValidationMessages.length > 0 && (
                            <div className="nibrs-tooltip-error" style={{ left: '-190px', pointerEvents: 'none' }} aria-hidden="true">
                                <div className="tooltip-arrow" />
                                <div className="tooltip-content">
                                    <span className="text-danger" style={{ whiteSpace: 'pre-line' }}>
                                        {`${assaultValidationMessages.map((m) => `⚠️ ${m}`).join('\n')}`}
                                    </span>
                                </div>
                            </div>
                        )}
                        <Select
                            name='AssaultID'
                            value={assaultID}
                            isClearable={false}
                            options={assaultDrp}
                            closeMenuOnSelect={false}
                            placeholder="Select.."
                            ref={SelectedValue}
                            className="basic-multi-select"
                            isMulti
                            components={{ MultiValue, }}
                            onChange={(e) => assaultOnChange(e)}
                            menuPlacement="bottom"
                            menuPortalTarget={null}
                            // isDisabled={nibrsSubmittedName === 1 && victimInjuryID?.length > 0}
                            styles={
                                isLockOrRestrictModule("Lock", assaultEditVal, isLocked, true) ? MultiSelectLockedStyle :
                                    (assaultValidationMessages.length > 0) ? nibrscolourStyles :
                                        loginAgencyState === 'TX' ?
                                            assultCodeArr?.includes("08") && offenceCodes?.length < 2 ? nibrscolourStyles
                                                :
                                                assult_Type_Nibrs_Errors(assultCodeArr, offenceCodes, 'Color') ? assult_Type_Nibrs_Errors(assultCodeArr, offenceCodes, 'Color') : customStylesWithOutColor
                                            :
                                            customStylesWithOutColor
                            }
                            isDisabled={isLockOrRestrictModule("Lock", assaultEditVal, isLocked, true) || (nibrsSubmittedName === 1 && victimInjuryID?.length > 0)}
                        />
                    </div>
                    <div className="col-2 col-md-2 col-lg-2 mt-3">
                        <label htmlFor="" className='label-name '>Property</label>
                    </div>
                    <div className="col-6 col-md-6 col-lg-10 mt-2">
                        <Select
                            options={propertyDrp}
                            value={propertyID}
                            isClearable={false}
                            closeMenuOnSelect={false}
                            placeholder="Select.."
                            ref={SelectedValue}
                            className="basic-multi-select"
                            isMulti
                            components={{ MultiValue, }}
                            onChange={(e) => PropertyOnChange(e)}
                            name='PropertyID'
                            menuPlacement="bottom"
                            menuPortalTarget={null}
                            // styles={customStylesWithOutColor}
                            styles={isLockOrRestrictModule("Lock", propertyEditVal, isLocked, true) ? MultiSelectLockedStyle : customStylesWithOutColor}
                            isDisabled={isLockOrRestrictModule("Lock", propertyEditVal, isLocked, true)}
                        />
                    </div>
                </div>
            </div>
            <ListModal {...{ openPage, setOpenPage }} />
        </>
    )
}

export default Home